document.addEventListener('DOMContentLoaded', function () {
  /* ================== SKELETON STYLES ================== */
  const skeletonStyle = document.createElement('style');
  skeletonStyle.textContent = [
    '.service-provider-loading { display: flex; flex-direction: column; gap: 16px; width: 100%; }',
    '.service-item-skeleton {',
    '  width: 100%; height: 130px; border-radius: 8px;',
    '  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);',
    '  background-size: 200% 100%;',
    '  animation: qcs-shimmer 1.4s infinite;',
    '}',
    '@keyframes qcs-shimmer {',
    '  0%   { background-position: 200% 0; }',
    '  100% { background-position: -200% 0; }',
    '}',
  ].join('');
  document.head.appendChild(skeletonStyle);

  const DEFAULT_DISTANCE_KM = 5;
  const EARTH_RADIUS_METERS = 6378137;
  const HALF_CIRCLE_DEG = 180;
  const DEG_TO_RAD = Math.PI / HALF_CIRCLE_DEG;
  const RAD_TO_DEG = HALF_CIRCLE_DEG / Math.PI;
  const HTTP_STATUS_OK = 200;
  const SCROLL_OFFSET_PX = 200;
  const DEFAULT_MAP_ZOOM = 12;

  /* ================== GLOBAL STATE ================== */
  let currentPage = 1;
  let currentXhr = null;
  let filterTimer = null;
  let currentView = 'list';
  let activeLocationCenter = null;

  /* ================== DEBOUNCE ================== */
  function scheduleFilter(reset) {
    if (reset === undefined) {
      reset = true;
    }
    clearTimeout(filterTimer);
    filterTimer = setTimeout(function () {
      runFilter(reset);
      if (currentView === 'map') {
        runMapFilter();
      }
    }, 100);
  }

  /* ================== ACCORDION ================== */
  document.querySelectorAll('.accordion-button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains('active');
      if (isActive) {
        this.classList.remove('active');
        content.style.display = 'none';
      } else {
        this.classList.add('active');
        content.style.display = 'flex';
      }
    });
  });

  /* ================== PREVENT ENTER ================== */
  const searchInput = document.getElementById('search-input');
  const locationSearch = document.getElementById('location-search');
  const locationValue = document.getElementById('location-value'); // hidden field

  if (searchInput) {
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        scheduleFilter(true);
      }
    });
  }

  if (locationSearch) {
    locationSearch.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });
  }

  /* ================== SORT DROPDOWN ================== */
  const sortHidden = document.getElementById('sort-hidden');
  const sortBtn = document.getElementById('resourceSortDropdown');

  document
    .querySelectorAll('.dropdown-item[data-sort]')
    .forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (sortHidden) {
          sortHidden.value = this.dataset.sort;
        }
        if (sortBtn) {
          sortBtn.textContent = this.textContent.trim();
        }
        document.querySelectorAll('.dropdown-item').forEach(function (i) {
          i.classList.remove('active');
        });
        this.classList.add('active');
        scheduleFilter(true);
      });
    });

  /* ================== DISTANCE FILTER ================== */
  const distanceFilter = document.getElementById('distance-filter');

  function getFilterRadiusKm() {
    if (distanceFilter) {
      return Number.parseFloat(distanceFilter.value) || DEFAULT_DISTANCE_KM;
    }
    return DEFAULT_DISTANCE_KM;
  }

  /* ================== GOOGLE PLACES AUTOCOMPLETE ================== */
  const clearLocationBtn = document.getElementById('clear-location');

  // Called by the Maps JS API once loaded (callback=qcsInitAutocomplete in script src)
  let autocompleteInitialized = false;
  window.qcsInitAutocomplete = function () {
    if (!locationSearch || autocompleteInitialized) {
      return;
    }
    if (!window.google?.maps?.places) {
      return;
    }
    autocompleteInitialized = true;

    const autocomplete = new google.maps.places.Autocomplete(locationSearch, {
      types: ['geocode'],
    });

    // Track whether a place was selected from the dropdown
    let placeSelected = false;

    autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();

      let resolvedAddress = locationSearch.value.trim();
      if (place?.formatted_address) {
        resolvedAddress = place.formatted_address;
      }

      if (place?.geometry?.location) {
        activeLocationCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
      } else {
        activeLocationCenter = null;
      }

      if (locationValue) {
        locationValue.value = resolvedAddress;
      }
      if (clearLocationBtn) {
        clearLocationBtn.style.display = 'block';
      }

      placeSelected = true;
      scheduleFilter(true);
    });

    // Only trigger filter if user explicitly picked a place from autocomplete
    locationSearch.addEventListener('blur', function () {
      if (!placeSelected && locationSearch.value.trim() === '') {
        if (locationValue) {
          locationValue.value = '';
        }
        activeLocationCenter = null;
        scheduleFilter(true);
      }
      placeSelected = false;
    });
  };

  // Poll until Maps API is ready (Google Maps script is loaded async)
  function tryInitAutocomplete() {
    if (autocompleteInitialized) {
      return;
    }
    if (window.google?.maps?.places) {
      window.qcsInitAutocomplete();
    } else {
      setTimeout(tryInitAutocomplete, 100);
    }
  }
  tryInitAutocomplete();

  /* ================== CLEAR LOCATION BUTTON ================== */
  if (clearLocationBtn) {
    clearLocationBtn.addEventListener('click', function () {
      if (locationSearch) {
        locationSearch.value = '';
      }
      if (locationValue) {
        locationValue.value = '';
      }
      activeLocationCenter = null;
      clearLocationBtn.style.display = 'none';
      scheduleFilter(true);
    });
  }

  /* ================== ALL OTHER FILTER TRIGGERS ================== */
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('auto-filter')) {
      return;
    }
    if (e.target.id === 'search-input') {
      return;
    }
    if (e.target.id === 'distance-filter') {
      return;
    }
    scheduleFilter(true);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('auto-filter')) {
      return;
    }
    if (e.target.id === 'search-input') {
      return;
    }
    if (e.target.id === 'location-search') {
      return;
    }
    scheduleFilter(true);
  });

  /* ================== DISTANCE SELECT (select2 compatible) ================== */
  function handleDistanceChange() {
    if (currentView === 'map' && gMap) {
      const center = getActiveCenter();
      if (center) {
        const radiusBounds = computeRadiusBounds(center, getFilterRadiusKm() * 1000);
        gMap.fitBounds(radiusBounds);
      }
    }
    scheduleFilter(true);
  }

  if (distanceFilter) {
    distanceFilter.addEventListener('change', handleDistanceChange);
    if (typeof jQuery !== 'undefined') {
      jQuery(distanceFilter).on('change select2:select select2:unselect', handleDistanceChange);
    }
  }

  /* ================== SHARED FILTER PARAMS (list + map) ================== */
  function appendCheckedGroup(data, inputName) {
    document.querySelectorAll(`input[name="${inputName}"]:checked`).forEach(function (cb) {
      data.append(inputName, cb.value);
    });
  }

  function buildFilterParams() {
    const data = new URLSearchParams();

    if (searchInput?.value?.trim()) {
      data.append('search', searchInput.value.trim());
    }

    if (sortHidden?.value) {
      data.append('sort', sortHidden.value);
    }

    appendCheckedGroup(data, 'categories[]');
    appendCheckedGroup(data, 'languages[]');
    appendCheckedGroup(data, 'age_group[]');
    appendCheckedGroup(data, 'gender[]');

    // Use the hidden location value (set by Autocomplete) and always send distance
    const locVal = locationValue?.value?.trim() || locationSearch?.value?.trim() || '';
    if (locVal) {
      data.append('locations', locVal);
      const distVal = distanceFilter?.value || String(DEFAULT_DISTANCE_KM);
      data.append('distance', distVal);
    }

    return data;
  }

  /* ================== AJAX FILTER ================== */
  const results = document.getElementById('service-results');

  function runFilter(reset) {
    if (reset === undefined) {
      reset = true;
    }
    if (!results) {
      return;
    }

    if (currentXhr) {
      currentXhr.abort();
      currentXhr = null;
    }

    if (reset) {
      currentPage = 1;
      const loadMoreBtn = document.getElementById('load-more-providers');
      if (loadMoreBtn) {
        loadMoreBtn.style.display = 'none';
      }
      results.innerHTML =
        '<div class="service-provider-loading">' +
        '<div class="service-item-skeleton"></div>' +
        '<div class="service-item-skeleton"></div>' +
        '<div class="service-item-skeleton"></div>' +
        '</div>';
      const providerList = document.querySelector('.service-provider-list');
      if (providerList) {
        const offset = SCROLL_OFFSET_PX;
        const top =
          providerList.getBoundingClientRect().top +
          window.pageYOffset -
          offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    const data = buildFilterParams();
    data.append('action', 'filter_service_providers');
    data.append('page', String(currentPage));

    const xhr = new XMLHttpRequest();
    currentXhr = xhr;
    xhr.open('POST', window.ajax_callback_data.ajax_url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function () {
      if (xhr.status !== HTTP_STATUS_OK) {
        return;
      }
      currentXhr = null;

      let res;
      try {
        res = JSON.parse(xhr.responseText);
      } catch (err) {
        results.innerHTML =
          "<p class='no-post'>Unexpected response. Please try again.</p>";
        return;
      }

      if (reset) {
        results.innerHTML = res.html;
      } else {
        results.insertAdjacentHTML('beforeend', res.html);
      }
      document.dispatchEvent(new CustomEvent('dv:content-updated'));

      const loadMoreBtn = document.getElementById('load-more-providers');
      if (loadMoreBtn) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.classList.remove('is-loading');
        if (res.has_more) {
          loadMoreBtn.style.display = 'inline-block';
          loadMoreBtn.dataset.page = res.next;
          loadMoreBtn.querySelector('span').textContent = 'Load More';
        } else {
          loadMoreBtn.style.display = 'none';
        }
      }
    };

    xhr.onerror = function () {
      currentXhr = null;
      results.innerHTML =
        "<p class='no-post'>Something went wrong. Please try again.</p>";
    };

    xhr.send(data.toString());
  }

  /* ================== LOAD MORE ================== */
  const loadMoreProviders = document.getElementById('load-more-providers');
  if (loadMoreProviders) {
    loadMoreProviders.addEventListener('click', function () {
      this.disabled = true;
      this.classList.add('is-loading');
      this.querySelector('span').textContent = 'Loading...';
      currentPage = parseInt(this.dataset.page);
      runFilter(false);
    });
  }

  /* ================== MAP VIEW ================== */
  const serviceMapEl = document.getElementById('service-map');
  const serviceMapEmpty = document.getElementById('service-map-empty');
  const viewToggleBtns = document.querySelectorAll('.view-toggle-btn');
  let gMap = null;
  let gMarkers = [];
  let gInfoWindow = null;
  let mapReadyWaitTimer = null;
  let isGeocodingCenter = false;

  function clearMapMarkers() {
    gMarkers.forEach(function (marker) {
      marker.setMap(null);
    });
    gMarkers = [];
  }

  function parseLatLngCoords(loc) {
    const parts = loc.split(',');
    if (parts.length === 2) {
      const lat = Number.parseFloat(parts[0]);
      const lng = Number.parseFloat(parts[1]);
      if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
        return { lat, lng };
      }
    }
    return null;
  }

  function geocodeAddress(address) {
    if (isGeocodingCenter || !window.google?.maps?.Geocoder) {
      return;
    }
    isGeocodingCenter = true;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, function (geocodeResults, status) {
      isGeocodingCenter = false;
      const location = geocodeResults?.[0]?.geometry?.location;
      if (status === 'OK' && location) {
        activeLocationCenter = { lat: location.lat(), lng: location.lng() };
        if (currentView === 'map' && gMap) {
          const bounds = computeRadiusBounds(activeLocationCenter, getFilterRadiusKm() * 1000);
          gMap.fitBounds(bounds);
        }
      }
    });
  }

  function getActiveCenter() {
    if (activeLocationCenter) {
      return activeLocationCenter;
    }

    const loc = locationValue?.value?.trim() || locationSearch?.value?.trim() || '';
    if (loc) {
      const coords = parseLatLngCoords(loc);
      if (coords) {
        activeLocationCenter = coords;
        return activeLocationCenter;
      }
      geocodeAddress(loc);
    }

    if (gMap && typeof gMap.getCenter === 'function') {
      const c = gMap.getCenter();
      if (c) {
        return { lat: c.lat(), lng: c.lng() };
      }
    }
    return null;
  }

  function computeRadiusBounds(center, radiusInMeters) {
    const latDelta = (radiusInMeters / EARTH_RADIUS_METERS) * RAD_TO_DEG;
    const latRad = center.lat * DEG_TO_RAD;
    const cosLat = Math.cos(latRad);
    let lngDelta = latDelta;
    if (Math.abs(cosLat) > 0.00001) {
      lngDelta = (radiusInMeters / (EARTH_RADIUS_METERS * Math.abs(cosLat))) * RAD_TO_DEG;
    }

    const southWest = new google.maps.LatLng(center.lat - latDelta, center.lng - lngDelta);
    const northEast = new google.maps.LatLng(center.lat + latDelta, center.lng + lngDelta);

    return new google.maps.LatLngBounds(southWest, northEast);
  }

  function createPinMarker(pin, bounds) {
    const position = { lat: pin.lat, lng: pin.lng };
    const marker = new google.maps.Marker({
      position,
      map: gMap,
      title: pin.title,
    });

    marker.addListener('click', function () {
      let distanceHtml = '';
      if (pin.dist_display) {
        distanceHtml = `<div class="service-item-distance"><b>${pin.dist_display}</b></div>`;
      }
      let logoHtml = '';
      if (pin.logo) {
        logoHtml = `<img src="${pin.logo}" alt="" style="width:48px;height:48px;object-fit:cover;border-radius:6px;margin-bottom:6px;">`;
      }

      gInfoWindow.setContent(
        `<div class="map-info-window">${logoHtml}<h6 style="margin:0 0 4px;">${pin.title}</h6>${distanceHtml}<a href="${pin.permalink}" class="btn btn-outline-primary btn-sm">View Details</a></div>`
      );
      gInfoWindow.open(gMap, marker);
    });

    gMarkers.push(marker);
    bounds.extend(position);
  }

  function handleEmptyPins(center, radiusMeters) {
    if (center) {
      serviceMapEl.style.display = 'block';
      if (serviceMapEmpty) {
        serviceMapEmpty.style.display = 'block';
      }
      if (!gMap) {
        gMap = new google.maps.Map(serviceMapEl, {
          center: { lat: center.lat, lng: center.lng },
          zoom: 12,
        });
        gInfoWindow = new google.maps.InfoWindow();
      }
      const emptyBounds = computeRadiusBounds(center, radiusMeters);
      gMap.fitBounds(emptyBounds);
    } else {
      serviceMapEl.style.display = 'none';
      if (serviceMapEmpty) {
        serviceMapEmpty.style.display = 'block';
      }
    }
  }

  function renderMapPins(pins) {
    if (!serviceMapEl) {
      return;
    }

    clearMapMarkers();

    const center = getActiveCenter();
    const radiusMeters = getFilterRadiusKm() * 1000;

    if (!pins?.length) {
      handleEmptyPins(center, radiusMeters);
      return;
    }

    serviceMapEl.style.display = 'block';
    if (serviceMapEmpty) {
      serviceMapEmpty.style.display = 'none';
    }

    if (!gMap) {
      let initialCenter = { lat: -25.2744, lng: 133.7751 }; // geographic center of Australia
      if (center) {
        initialCenter = { lat: center.lat, lng: center.lng };
      }
      gMap = new google.maps.Map(serviceMapEl, {
        center: initialCenter,
        zoom: 5,
      });
      gInfoWindow = new google.maps.InfoWindow();
    }

    let bounds = new google.maps.LatLngBounds();
    if (center) {
      bounds = computeRadiusBounds(center, radiusMeters);
    }

    pins.forEach(function (pin) {
      createPinMarker(pin, bounds);
    });

    if (center) {
      gMap.fitBounds(bounds);
    } else if (pins.length === 1) {
      gMap.setCenter({ lat: pins[0].lat, lng: pins[0].lng });
      gMap.setZoom(DEFAULT_MAP_ZOOM);
    } else {
      gMap.fitBounds(bounds);
    }
  }

  function runMapFilter() {
    if (!serviceMapEl) {
      return;
    }

    // Google Maps JS loads async and may not be ready yet even though the
    // enqueue for it is unconditional/sitewide — poll briefly rather than
    // assuming it's present (a separate, more robust check than the
    // DOMContentLoaded-time check used for the location Autocomplete above).
    if (!window.google?.maps) {
      clearTimeout(mapReadyWaitTimer);
      mapReadyWaitTimer = setTimeout(runMapFilter, 150);
      return;
    }

    const data = buildFilterParams();
    data.append('action', 'get_service_provider_map_pins');

    const xhr = new XMLHttpRequest();
    xhr.open('POST', window.ajax_callback_data.ajax_url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function () {
      if (xhr.status !== HTTP_STATUS_OK) {
        return;
      }
      let res;
      try {
        res = JSON.parse(xhr.responseText);
      } catch (err) {
        return;
      }
      renderMapPins(res.pins);
    };

    xhr.send(data.toString());
  }

  function updateViewToggleButtons(activeBtn) {
    viewToggleBtns.forEach(function (b) {
      const isActive = b === activeBtn;
      b.classList.toggle('is-active', isActive);
      if (isActive) {
        b.setAttribute('aria-pressed', 'true');
      } else {
        b.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function toggleViewElements(isMap) {
    const loadMoreWrap = document.querySelector('.load-more-wrap');
    if (isMap) {
      if (results) {
        results.style.display = 'none';
      }
      if (loadMoreWrap) {
        loadMoreWrap.style.display = 'none';
      }
      if (serviceMapEl) {
        serviceMapEl.style.display = 'block';
      }
    } else {
      if (results) {
        results.style.display = '';
      }
      if (loadMoreWrap) {
        loadMoreWrap.style.display = '';
      }
      if (serviceMapEl) {
        serviceMapEl.style.display = 'none';
      }
      if (serviceMapEmpty) {
        serviceMapEmpty.style.display = 'none';
      }
    }
  }

  function handleViewToggle(btn) {
    const view = btn.dataset.view;
    if (view === currentView) {
      return;
    }
    currentView = view;
    updateViewToggleButtons(btn);

    const isMap = (view === 'map');
    toggleViewElements(isMap);

    if (isMap) {
      if (gMap) {
        google.maps.event.trigger(gMap, 'resize');
      }
      runMapFilter();
    }
  }

  if (viewToggleBtns.length) {
    viewToggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleViewToggle(this);
      });
    });
  }

  /* ================== INITIAL LOAD ================== */
  runFilter(true);

  /* ================== AUTO-APPLY IP-BASED LOCATION ================== */
  // Pre-fill the same location fields Places Autocomplete writes to, then
  // re-run the existing filter pipeline. Any manual search/clear afterward
  // simply overwrites these fields as it already does today.
  if (locationValue && !locationValue.value.trim() && typeof window.qcsGetVisitorGeo === 'function') {
    window.qcsGetVisitorGeo(function (result) {
      if (!result?.success || result.lat == null || result.lng == null) {
        return;
      }
      if (locationValue.value.trim()) {
        return; // user already picked a location while we waited
      }

      let displayName = result.city;
      if (result.region) {
        displayName = `${result.city}, ${result.region}`;
      }
      if (locationSearch) {
        locationSearch.value = displayName;
      }
      locationValue.value = `${result.lat},${result.lng}`;
      activeLocationCenter = {
        lat: Number.parseFloat(result.lat),
        lng: Number.parseFloat(result.lng),
      };
      if (clearLocationBtn) {
        clearLocationBtn.style.display = 'block';
      }

      scheduleFilter(true);
    });
  }

  /* ================== CLEAR ALL FILTERS ================== */
  const clearBtn = document.getElementById('clear-filters');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      document
        .querySelectorAll('input[type="checkbox"]')
        .forEach(function (cb) {
          cb.checked = false;
        });
      if (locationSearch) {
        locationSearch.value = '';
      }
      if (locationValue) {
        locationValue.value = '';
      }
      activeLocationCenter = null;
      if (searchInput) {
        searchInput.value = '';
      }

      if (sortHidden) {
        sortHidden.value = '';
      }
      if (sortBtn) {
        sortBtn.textContent = 'Sort By';
      }
      document.querySelectorAll('.dropdown-item').forEach(function (i) {
        i.classList.remove('active');
      });

      if (clearLocationBtn) {
        clearLocationBtn.style.display = 'none';
      }

      if (distanceFilter) {
        distanceFilter.value = String(DEFAULT_DISTANCE_KM);
        if (typeof jQuery !== 'undefined') {
          jQuery(distanceFilter).val(String(DEFAULT_DISTANCE_KM)).trigger('change.select2');
        }
      }

      runFilter(true);
      if (currentView === 'map') {
        runMapFilter();
      }
    });
  }
});
